module.exports = new __parcel__URL__("sparkle.c93894f3.svg").toString();